import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { setTokenCookie, setAdminTypeCookie } from "./cookie";
import styles from "./Login.module.css";
import axios from "axios";

function Login({ onAdminTypeChange }) {
  const [loginIdentifier, setLoginIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [loginTypeChoice, setLoginTypeChoice] = useState("Amebo");
  const navigate = useNavigate();

  const handleIdentifierChange = (event) => {
    setLoginIdentifier(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const handleSelectChange = (event) => {
    setLoginTypeChoice(event.target.value);
  };

  const handleLogin = async (event) => {
    event.preventDefault();

    let loginType = "email";

    if (/^\d{11}$/.test(loginIdentifier)) {
      loginType = "cuit";
    }

    let apiUrl;
    let apiUrlSupplier;

    // Usar la versión actualizada de loginTypeChoice aquí
    const currentLoginTypeChoice = loginTypeChoice;

    if (currentLoginTypeChoice === "Lealtad") {
      apiUrl = process.env.REACT_APP_LOGIN_API_LEALTAD;
      apiUrlSupplier = process.env.REACT_APP_LOGIN_SUPPLIER_API_LEALTAD;
    } else {
      apiUrl = process.env.REACT_APP_LOGIN_API;
      apiUrlSupplier = process.env.REACT_APP_LOGIN_SUPPLIER_API;
    }

    try {
      const res = await axios.post(
        loginType === "email" ? apiUrl : apiUrlSupplier,
        {
          [loginType]: loginIdentifier,
          password,
        }
      );

      if (res.data.success) {
        onAdminTypeChange(res.data.adminType);
        setTokenCookie(res.data.token);
        setAdminTypeCookie(res.data.adminType);
        sessionStorage.setItem("adminType", res.data.adminType);

        setTimeout(() => {
          sessionStorage.removeItem("adminType");
        }, 3600000); // 1 hour

        Swal.fire({
          icon: "success",
          title: "Bienvenido!",
          text: "Has iniciado sesión correctamente.",
        });

        if (res.data.adminType === "Lealtad") {
          navigate("/inicio-lealtad");
        } else if (res.data.adminType === "Amebo") {
          navigate("/inicio");
        } else if (res.data.adminType === "Proveedor") {
          if (res.data.dataCompleted) {
            navigate("/portal-proveedor/inicio", { state: res.data.data });
          } else {
            navigate("/portal-proveedor/completar-datos", {
              state: res.data.data,
            });
          }
        } else if (res.data.adminType === "Comercializador") {
          if (res.data.dataCompleted) {
            navigate("/portal-comercializadores/inicio", {
              state: res.data.data,
            });
          } else {
            navigate("/portal-comercializadores/completar-datos", {
              state: res.data.data,
            });
          }
        } else if (res.data.adminType === "SupplierAdmin") {
          if (res.data.dataCompleted) {
            navigate("/portal-admin-proveedor/inicio", {
              state: res.data.data,
            });
          } else {
            navigate("/portal-admin-proveedor/completar-datos", {
              state: res.data.data,
            });
          }
        } else if (res.data.adminType === "ProveedorLealtad") {
          if (res.data.dataCompleted) {
            navigate("/portal-proveedor-lealtad/inicio", {
              state: res.data.data,
            });
          } else {
            navigate("/portal-proveedor-lealtad/completar-datos", {
              state: res.data.data,
            });
          }
        } else if (res.data.adminType === "ComercializadorLealtad") {
          if (res.data.dataCompleted) {
            navigate("/portal-comercializadores-lealtad/inicio", {
              state: res.data.data,
            });
          } else {
            navigate("/portal-comercializadores-lealtad/completar-datos", {
              state: res.data.data,
            });
          }
        } else if (res.data.adminType === "SupplierAdminLealtad") {
          if (res.data.dataCompleted) {
            navigate("/portal-admin-proveedor-lealtad/inicio", {
              state: res.data.data,
            });
          } else {
            navigate("/portal-admin-proveedor-lealtad/completar-datos", {
              state: res.data.data,
            });
          }
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Usuario o contraseña incorrectos.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "parece que hubo un error",
      });
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>Iniciar Sesión</div>
      <form className={styles.formLogin} onSubmit={handleLogin}>
        <div className={styles.TextForm}>Entidad</div>
        <select
          id="opciones"
          name="opciones"
          className={styles.inputForm}
          value={loginTypeChoice}
          onChange={handleSelectChange}
        >
          <option value="Amebo">Amebo</option>
          <option value="Lealtad">Lealtad</option>
        </select>
        <div className={styles.TextForm}>Usuario</div>
        <input
          type="text"
          value={loginIdentifier}
          className={styles.inputForm}
          onChange={handleIdentifierChange}
          placeholder="Correo Electrónico o CUIT"
          autoComplete="username"
        />
        <div className={styles.TextForm}>Contraseña</div>
        <input
          type="password"
          className={styles.inputForm}
          value={password}
          onChange={handlePasswordChange}
          placeholder="Contraseña"
          autoComplete="current-password"
        />
        <button type="submit" className={styles.loginButton}>
          Iniciar sesión
        </button>
      </form>
    </div>
  );
}

export default Login;
